import { render, staticRenderFns } from "./swiper_first_tab.vue?vue&type=template&id=23e16912&scoped=true"
import script from "./swiper_first_tab.vue?vue&type=script&lang=js"
export * from "./swiper_first_tab.vue?vue&type=script&lang=js"
import style0 from "./swiper_first_tab.vue?vue&type=style&index=0&id=23e16912&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e16912",
  null
  
)

export default component.exports